import { render, staticRenderFns } from "./veStuAssocMemberEdit.vue?vue&type=template&id=e3da8970&scoped=true"
import script from "./veStuAssocMemberEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocMemberEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da8970",
  null
  
)

export default component.exports